import React, {useState, useRef} from 'react';
import {Checkbox, Button} from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PostCode from 'japan-postal-code'
import StyledButton from '../style'
import {Link} from 'react-router-dom'
import {
  RGX_NAME_KANA,
  NUMBER_PHONES,
  REGEX_POSTCODE,
  REGEX_EMAIL,
  REGEX_CHARACTER
} from '../../../config/contants/regex'
import ClientAPI from "../../../api/clients";
import filePDF from '../../../assets/files/サービス利用規約_ver7.pdf';

function Register(props) {
  const {setStep, valueForm, setValueForm, errorForm, setErrorForm, initialValue, isBack} = props
  const [checked, setChecked] = useState(false)
  const CustomStyleButton = StyledButton()
  const clinicNameRef = useRef(null)
  const postCodeRef = useRef(null)
  const cityRef = useRef(null)
  const addressRef = useRef(null)
  const telRef = useRef(null)
  const nameRef = useRef(null)
  const nameKataRef = useRef(null)
  const emailRef = useRef(null)
  const applicationCodeRef = useRef(null)

  const handleChangeValue = (event) => {
    const {name, value} = event.target
    const newValue = {
      ...valueForm,
      [name]: value
    }
    setValueForm(newValue)
  }

  const handleChangePostCode = (event) => {
    const {name, value} = event.target
    const newValue = {
      ...valueForm,
      [name]: value
    }
    if (value !== '') {
      let valuePrefecture = '';
      let valueCity = '';
      let valueArea = '';

      PostCode.get(value, (address) => {
        valuePrefecture = address.prefecture ?? '';
        valueCity = address.city ?? '';
        valueArea = address.area ?? '';
      });
      newValue.city = valuePrefecture; // reversed between: prefecture && city
      newValue.address = valueCity + valueArea;
    } else {
      newValue.city = ''
    }
    setValueForm(newValue)
  }

  const handleScrollError = (error) => {
    if (error.name_clinic) {
      clinicNameRef.current.scrollIntoView();
    } else if (error.postcode) {
      postCodeRef.current.scrollIntoView();
    } else if (error.city) {
      cityRef.current.scrollIntoView();
    } else if(error.address) {
      addressRef.current.scrollIntoView();
    } else if (error.tel) {
      telRef.current.scrollIntoView();
    } else if (error.first_name_client || error.last_name_client) {
      nameRef.current.scrollIntoView();
    } else if (error.first_name_kana || error.last_name_kana) {
      nameKataRef.current.scrollIntoView();
    } else if (error.email) {
      emailRef.current.scrollIntoView();
    } else if (error.application_code) {
      applicationCodeRef.current.scrollIntoView();
    }
  }

  const handleSubmit = () => {
    const error = {...initialValue}
    let count = 0;
    for (const key in valueForm) {
      if (
        valueForm[key] === null ||
        valueForm[key] === "" ||
        ((typeof valueForm[key] === 'string' || valueForm[key] instanceof String) && valueForm[key].trim() === '')
      ) {
        count+=1
        error[key] = '必須項目です。'
      }
    }

    if (valueForm.name_clinic && valueForm.name_clinic.length > 255) {
      count +=1
      error.name_clinic = '255文字以下で入力してください。';
    }

    if (valueForm.address && valueForm.address.length > 255) {
      count +=1
      error.address = '255文字以下で入力してください。';
    }

    if (valueForm.first_name_client && valueForm.first_name_client.length > 10) {
      count +=1
      error.first_name_client = '10文字以下で入力してください。';
    } else if (valueForm.first_name_client && REGEX_CHARACTER.test(valueForm.first_name_client)) {
      count +=1
      error.first_name_client = '数字を入力してはいけません。';
    }

    if (valueForm.last_name_client && valueForm.last_name_client.length > 10) {
      count +=1
      error.last_name_client = '10文字以下で入力してください。';
    } else if (valueForm.last_name_client && REGEX_CHARACTER.test(valueForm.last_name_client)) {
      count +=1
      error.last_name_client = '数字を入力してはいけません。';
    }

    if (valueForm.first_name_kana && valueForm.first_name_kana.length > 10) {
      count +=1
      error.first_name_kana = '10文字以下で入力してください。';
    } else if (valueForm.first_name_kana && !RGX_NAME_KANA.test(valueForm.first_name_kana)) {
      count +=1
      error.first_name_kana = 'カタカナを入力してください。';
    }

    if (valueForm.last_name_kana && valueForm.last_name_kana.length > 10) {
      count +=1
      error.last_name_kana = '10文字以下で入力してください。';
    } else if (valueForm.last_name_kana && !RGX_NAME_KANA.test(valueForm.last_name_kana)) {
      count +=1
      error.last_name_kana = 'カタカナを入力してください。';
    }

    if (valueForm.postcode && !REGEX_POSTCODE.test(valueForm.postcode)) {
      count +=1
      error.postcode = '郵便番号を正しく入力してください。';
    }

    if (valueForm.tel && !NUMBER_PHONES.test(valueForm.tel)) {
      count +=1
      error.tel = valueForm.tel.indexOf("-") >= 0 ? 'ハイフンを抜いて入力してください。' : '電話番号の形式が正しくありません。';
    }

    if(valueForm.email && !REGEX_EMAIL.test(valueForm.email)) {
      count +=1
      error.email = 'メールアドレスを正しく入力してください。';
    }

    if (valueForm.application_code && valueForm.application_code.length > 255) {
      count +=1
      error.application_code = '255文字以下で入力してください。';
    }

    handleScrollError(error)
    if (count === 0) {
      valueForm.is_validate = true
      valueForm.name_client = `${valueForm.first_name_client}${valueForm.last_name_client}`
      valueForm.name_kana = `${valueForm.first_name_kana}${valueForm.last_name_kana}`
      ClientAPI.register(valueForm)
        .then(() => {
          setStep(2)
          window.scrollTo(0, 0)
        })
        .catch(async error => {
          const {errors} = await error.response.data
          if (errors.client.email) {
            error.email = errors.client.email[0]
          }

          if (errors.clinic.tel) {
            error.tel = errors.clinic.tel[0]
          }
          handleScrollError(error)
          setErrorForm(error)
        })
    }
    setErrorForm(error)
  }

  return (
    <div id='group-register'>
      <div className='header' />
      <div className='content'>
        <span className='title'>ご利用お申し込み画面</span>
        <span className='description'>「Dental.DX」の利用申込画面です。Dental.DXは歯科クリニック・医院から患者様へパーソナライズド動画送信を行うことができるコンソールシステムです。</span>
        <span className='description'>こちらに入力された個人情報はツールの利用開始にあたり使用するもので、第三者への開示・提供は一切いたしません。</span>
        <span className='description'>ご記入いただく情報はお客様情報として使用するため、正しく入力してください。</span>
        <span className='description highlight'>
          <ul className='notes'>
            <li className='notes'>
              こちらにご入力いただいたメールアドレスは、未配信のリマインドやエラー通知など「配信に関する重要なメールの受信先」として設定させていただきます。<br />
              今後システムをご使用いただく上で、確認しやすいメールアドレスをご入力ください。
            </li>
          </ul>
        </span>

        <div className='hr'/>

        <div ref={clinicNameRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              法人名（クリニック名）
            </div>
            <input
              value={valueForm.name_clinic}
              name='name_clinic'
              onChange={handleChangeValue}
              className={`form-control w-67 ${errorForm.name_clinic ? 'input-error' : ''}`}
              type="text"
              placeholder='例)医療法人令和クリニック'/>
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.name_clinic && <span className='error'>{errorForm.name_clinic}</span>}
          </div>
        </div>

        <div className='hr'/>

        <div ref={postCodeRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              郵便番号
            </div>
            <input
              value={valueForm.postcode}
              className={`form-control w-20 ${errorForm.postcode ? 'input-error' : ''}`}
              type="text"
              name='postcode'
              onChange={handleChangePostCode}
              onBlur={handleChangePostCode}
              placeholder='例)000-0000'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.postcode && <span className='error'>{errorForm.postcode}</span>}
          </div>
        </div>

        <div ref={cityRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              都道府県
            </div>
            <input
              value={valueForm.city}
              className={`form-control w-29 ${errorForm.city ? 'input-error' : ''}`}
              type="text"
              onChange={event => event.preventDefault()}
              placeholder=''
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.city && <span className='error'>{errorForm.city}</span>}
          </div>
        </div>

        <div ref={addressRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              住所
            </div>
            <input
              value={valueForm.address}
              onChange={handleChangeValue}
              name='address'
              className={`form-control w-67 ${errorForm.address ? 'input-error' : ''}`}
              type="text"
              placeholder='例)台東区台東4-31-1 ALビル001'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.address && <span className='error'>{errorForm.address}</span>}
          </div>
        </div>


        <div className='hr'/>

        <div ref={telRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              電話番号
            </div>
            <input
              value={valueForm.tel}
              onChange={handleChangeValue}
              className={`form-control w-67 ${errorForm.tel ? 'input-error' : ''}`}
              name='tel'
              type="text"
              placeholder='ハイフンなし'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.tel && <span className='error'>{errorForm.tel}</span>}
          </div>
        </div>

        <div className='hr'/>

        <div ref={nameRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              契約者氏名
            </div>
            <input
              value={valueForm.first_name_client}
              onChange={handleChangeValue}
              name='first_name_client'
              className={`form-control w-29 m-10-r ${errorForm.first_name_client ? 'input-error' : ''}`}
              type="text"
              placeholder='姓'
            />
            <input
              value={valueForm.last_name_client}
              onChange={handleChangeValue}
              name='last_name_client'
              className={`form-control w-29 ${errorForm.last_name_client ? 'input-error' : ''}`}
              type="text"
              placeholder='名'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            <span className='error w-29 mr-22'>{errorForm.first_name_client}</span>
            <span className='error w-29'>{errorForm.last_name_client}</span>
          </div>
        </div>

        <div ref={nameKataRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              契約者氏名フリガナ
            </div>
            <input
              value={valueForm.first_name_kana}
              onChange={handleChangeValue}
              name='first_name_kana'
              className={`form-control w-29 m-10-r ${errorForm.first_name_kana ? 'input-error' : ''}`}
              type="text"
              placeholder='セイ'
            />
            <input
              value={valueForm.last_name_kana}
              onChange={handleChangeValue}
              name='last_name_kana'
              className={`form-control w-29 ${errorForm.last_name_kana ? 'input-error' : ''}`}
              type="text"
              placeholder='メイ'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            <span className='error w-29 mr-22'>{errorForm.first_name_kana}</span>
            <span className='error w-29'>{errorForm.last_name_kana}</span>
          </div>
        </div>

        <div className="hr"/>

        <div ref={emailRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              <div className='required'>必須</div>
              契約者メールアドレス
            </div>
            <input
              value={valueForm.email}
              onChange={handleChangeValue}
              name='email'
              className={`form-control w-67 ${errorForm.email ? 'input-error' : ''}`}
              type="text"
              placeholder='例)reiwaclinic_5555@clinic.jp'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.email && <span className='error'>{errorForm.email}</span>}
          </div>
        </div>

        <div className="hr"/>

        <div ref={applicationCodeRef} className='parent-group-form'>
          <div className='group-form'>
            <div className='label-input'>
              お申し込みコード
            </div>
            <input
                value={valueForm.application_code}
                onChange={handleChangeValue}
                name='application_code'
                className={`form-control w-67 ${errorForm.application_code ? 'input-error' : ''}`}
                type="text"
                placeholder='お申込みコードがある場合、ご入力ください。'
            />
          </div>
          <div className="flex">
            <div className='label-input'/>
            {errorForm.application_code && <span className='error'>{errorForm.application_code}</span>}
          </div>
        </div>

        <div className="hr"/>
      </div>

      <div className='group-button'>
        <span className='policy'>
          <Link to={filePDF} target="_blank">利用規約</Link>
        </span>
        <span>をご確認の上、お申込みを完了してください。</span>
        <div className='checkbox-group'>
          <Checkbox
            id='checkbox-policy'
            checked={isBack || checked}
            onChange={() => setChecked(!checked)}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          <label className='cursor-pointer' htmlFor='checkbox-policy'>利用規約を確認し、同意しました。</label>
        </div>
        <Button
          disabled={!isBack && !checked}
          variant="contained"
          classes={CustomStyleButton}
          onClick={handleSubmit}
        >
          同意して入力内容の確認へすすむ <ArrowForwardIosIcon fontSize='inherit' />
        </Button>
      </div>
    </div>
  );
}

export default Register;
